import { FunctionComponent } from 'react';
import styles from './CheckboxTagList.module.scss';
import classNames from 'classnames';

interface CheckboxOption {
  id: string;
  label: string;
}

interface CheckboxTagListProps {
  options: CheckboxOption[];
  selectedOptions: string[];
  onChange: (selectedIds: string[]) => void;
  mode?: 'checkbox' | 'radio' | string;
  className?: string;
}

const CheckboxTagList: FunctionComponent<CheckboxTagListProps> = ({
  options,
  selectedOptions,
  onChange,
  mode = 'checkbox',
  className = '',
}) => {
  const handleToggle = (id: string) => {
    let newSelectedOptions: string[];

    if (mode === 'radio') {
      newSelectedOptions = [id]; // only one can be selected
    } else {
      newSelectedOptions = selectedOptions.includes(id)
        ? selectedOptions.filter((item) => item !== id)
        : [...selectedOptions, id];
    }

    onChange(newSelectedOptions);
  };

  return (
    <div className={classNames(styles['list'], className)}>
      {options?.map((option) => (
        <label
          className={classNames(styles['checkbox'], selectedOptions.includes(option.id) ? styles['active'] : '')}
          key={option.id}
        >
          <input
            className={styles['checkbox__real']}
            type={mode}
            checked={selectedOptions.includes(option.id)}
            onChange={() => handleToggle(option.id)}
          />

          <div className={styles['checkbox__custom']}>
            <span className={classNames(styles['checkbox__label'], 'text text--body-2')}>{option.label}</span>
          </div>
        </label>
      ))}
    </div>
  );
};

export default CheckboxTagList;
